// Display names for the examinations picker (C6) and the test screens.
// The test keys and ids come from api/companies/current/ (enabled_categorised_tests) and are sent
// unchanged; only the labels shown to the clinician change here.
//   - "ICN Vision" is called "Near Vision" in the IBISengage design.
//   - Second versions of a test get a "V2" suffix (Figma "Kay's Optotypes V2", "Visual Field V2").

const VERSION_BY_KEY = {
  kaysMultiple: 'V2',
  visualFieldTwo: 'V2',
  RefractionTwo: 'V2',
};

const NAME_BY_KEY = {
  optimaChart: 'Near Vision',
  openLogmar: 'Open logMAR',
  crowdedLogmar: 'Crowded logMAR',
  randomE: 'Random E',
  kaysOptotypes: "Kay's Optotypes",
  kaysMultiple: "Kay's Optotypes",
  ishihara: 'Colour Vision',
};

/** Name shown for a test in the picker ("Near Vision", "Kay's Optotypes V2"). */
export const examDisplayName = (test) => {
  if (!test) return '';
  const base = NAME_BY_KEY[test.key] || String(test.title || test.key || '').replace(/\bICN Vision\b/i, 'Near Vision');
  const version = VERSION_BY_KEY[test.key];
  if (!version || new RegExp(`\\b${version}\\b`, 'i').test(base)) return base;
  return `${base} ${version}`;
};

/** Header title of a test screen ("Open logMAR Test", "Near Vision"). */
export const examTitle = (testKey) => {
  switch (testKey) {
    case 'openLogmar':
      return 'Open logMAR Test';
    case 'crowdedLogmar':
      return 'Crowded logMAR Test';
    case 'randomE':
      return 'Random E Test';
    case 'optimaChart':
      return 'Near Vision';
    case 'kaysOptotypes':
      return "Kay's Optotypes Test";
    case 'kaysMultiple':
      return "Kay's Optotypes V2 Test";
    default:
      return 'Examinations';
  }
};

/** Suffix used in the header per eye step ("- Right Eye"). */
export const eyeTitleSuffix = (step = '') => {
  if (step.startsWith('rightEye')) return ' - Right Eye';
  if (step.startsWith('leftEye')) return ' - Left Eye';
  if (step.startsWith('bothEyes')) return ' - Binocular';
  if (step === 'results') return ' Results';
  return '';
};

/**
 * Normalises api/companies/current/ enabled_categorised_tests ({id: {title, key, thumbnail_url,
 * tests:[{key,title,test_id,async_test}]}}) into picker categories. Only tests the session app
 * can run (a testsMap entry, see helpers/data.js) are offered; the rest (e.g. async self-tests)
 * would have no screen to open.
 */
export const toPickerCategories = (enabled, runnable = () => true) =>
  Object.entries(enabled || {})
    .map(([id, category]) => ({
      id,
      key: category.key,
      title: category.title,
      image: isImageUrl(category.thumbnail_url) ? category.thumbnail_url : null,
      tests: (category.tests || [])
        .filter((t) => runnable(t.key))
        .map((t) => ({ ...t, label: examDisplayName(t) })),
    }))
    .filter((c) => c.tests.length > 0);

const isImageUrl = (url) => typeof url === 'string' && /^(https?:)?\/\/|^\/|^data:image\//.test(url);
